module.exports = __webpack_public_path__ + "static/home-about-new-800c5032313f4e8618c3c5b0b134393c.png";